import { render, staticRenderFns } from "./CompanyJixiaoTotalReport.vue?vue&type=template&id=c47b92a2&scoped=true"
import script from "./CompanyJixiaoTotalReport.vue?vue&type=script&lang=js"
export * from "./CompanyJixiaoTotalReport.vue?vue&type=script&lang=js"
import style0 from "./CompanyJixiaoTotalReport.vue?vue&type=style&index=0&id=c47b92a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47b92a2",
  null
  
)

export default component.exports